import { render, staticRenderFns } from "./HomeLayout.vue?vue&type=template&id=5c16a8ae&scoped=true"
import script from "./HomeLayout.vue?vue&type=script&lang=ts"
export * from "./HomeLayout.vue?vue&type=script&lang=ts"
import style0 from "./HomeLayout.vue?vue&type=style&index=0&id=5c16a8ae&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c16a8ae",
  null
  
)

export default component.exports